/**
 * Invitation acceptance requirements enum.
 *
 * Determines what action the user should follow in order
 * for the invite to be accepted.
 *
 * @alias INVITATION_ACCEPTANCE_REQUIREMENT
 * @readonly
 * @type {{CONFIRM_EMAIL: string, CONFIRM_PHONE_NUMBER: string, NONE: string}}
 */
export const INVITATION_ACCEPTANCE_REQUIREMENT = {
  CONFIRM_EMAIL: 'CONFIRM_EMAIL',
  CONFIRM_PHONE_NUMBER: 'CONFIRM_PHONE_NUMBER',
  NONE: 'NONE',
};
